import { NewColorScheme } from '../default/Colors';

export { NewColorScheme };
export default NewColorScheme;
